module.exports = __webpack_public_path__ + "static/media/1_simplex_A_orange_square.a88a224b.png";